const Preferences = () => {
  return 'Preferences'
}

export default Preferences
